import LazyLoadImage from '@fingo/lib/components/images/LazyLoadImage';
import { FingoNavbar } from '@fingo/lib/components/layout';
import { LoggedOutNavItems } from '@fingo/lib/components/layout/navbar';
import LogoWithRedirectLink from '@fingo/lib/components/logo/LogoWithRedirectLink';
import { useGetUser, useIsLogged } from '@fingo/lib/hooks';
import React, { useMemo } from 'react';
// TODO: Create file with platform logo
import ItauLogo from '@fingo/lib/assets/icons/logos/itau';
import LoggedInDesktopNavItems from './LoggedInDesktopNavItems';

const DesktopNavbar = () => {
  const isLogged = useIsLogged();
  const user = useGetUser();
  const navbar = useMemo(() => (
    <FingoNavbar useGradient={false}>
      <LogoWithRedirectLink
        image={(
          <LazyLoadImage
            src={ItauLogo}
            alt="itau logo"
            width={57}
            height={56}
            format="avif"
          />
        )}
        isLogged={isLogged}
      />
      {isLogged && user && <LoggedInDesktopNavItems />}
      {!isLogged && <LoggedOutNavItems title="Iniciar Sesión" to="/login" />}
    </FingoNavbar>

  ), [isLogged, user]);
  return navbar;
};

export default DesktopNavbar;
